import { APP_PERMISSIONS } from '@exam-center/permission';
import { PermissionRoute, type PermissionRouteData } from '@exam-center/router';
import { dayjs } from '@shared/utils';

export default function ExamDistributionPage() {
  const currentYear = dayjs().year();

  const routes: PermissionRouteData[] = [
    {
      path: '/admin/exam-distribution/year/:year',
      requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.EXAM_ASSIGNING.VIEW],
      params: {
        year: currentYear.toString(),
      },
    },
    {
      path: '/admin/exam-distribution/available-qsets',
      requiredPermission: [APP_PERMISSIONS.ADMIN_EXAM_DISTRIBUTION.AVAILABLE_QSETS.VIEW],
    },
  ];

  return <PermissionRoute routes={routes} />;
}
